// ─── Types (matching new backend API) ───────────────────────────────────────

export interface Article {
  id: string
  itemCode: string
  itemName: string
  groupId?: string
  groupName?: string
  manufacturer?: string
  barCode?: string
  salesPrice: number
  purchasePrice: number
  margin: number
  unit: string
  stockQuantity?: number
  isActive: boolean
  syncStatus: 'synced' | 'local_only' | 'conflict'
  lastSyncedAt?: string
  locallyModifiedAt?: string | null
}

export interface ArticleGroup {
  id: string
  sapGroupCode?: number
  groupCode?: number
  name: string
  description?: string
  icon?: string
  parentGroupId?: string
  tanssLinkTypeId?: number
  tanssTypeId?: number
  sortOrder: number
  isTitle: boolean
  isActive: boolean
  requiresSerialNumber: boolean
  serialNumberMinPrice?: number | null
  minStock: number
  maxStock: number
  isCustomerProperty: boolean
  oldSapGroupCode?: number
  articleCount: number
  syncTenantIds?: string[] | null
  defaultSapItemType?: string | null
  defaultSapUomGroupEntry?: number | null
  defaultSapInventoryItem?: boolean | null
  defaultSapPurchaseItem?: boolean | null
  defaultSapSalesItem?: boolean | null
}

export interface ArticleListResponse {
  data: Article[]
  total: number
  page: number
  pageSize: number
}

export interface ArticleSyncConflict {
  id: string
  articleId: string
  articleItemCode?: string
  articleItemName?: string
  tenantId: string
  tenantCode?: string
  field: string
  centralValue?: string
  remoteValue?: string
  status: string
  createdAt: string
}

export type SubPage = 'articles' | 'conflicts' | 'missing-sync' | 'ai' | 'content-standard' | 'egis' | 'text-adjustment' | 'margin-analysis' | 'eol-tracking' | 'supplier-prices' | 'inventory-turnover' | 'units' | 'ai-verification' | 'service-catalog'

export const formatCurrency = (v: number) =>
  new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(v)

// Helper to extract error message from Axios errors (includes server response detail)
export function getErrorMessage(err: Error | null): string {
  if (!err) return 'Unbekannter Fehler'
  const axiosErr = err as Error & { response?: { data?: { error?: string; message?: string } } }
  const serverMsg = axiosErr.response?.data?.error || axiosErr.response?.data?.message
  return serverMsg || err.message
}
